<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <b-navbar-nav />
    </div>

    <!-- Right Col -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <dark-Toggler class="d-none d-block" />

      <b-nav-item-dropdown
        v-if="loggedIn"
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user d-none d-flex"
      >
        <template #button-content>
          <b-badge
            v-if="false"
            pill
            :variant="companySubscription.variant"
            class="navbar-company-status mr-1"
            :title="`Company subscription: ${companySubscription.label}`"
            :aria-label="`Company subscription: ${companySubscription.label}`"
          >
            <span class="navbar-company-status-label">{{ companySubscription.label }}</span>
          </b-badge>
          <div class="d-flex d-none user-nav navbar-account-text">
            <p
              class="user-name font-weight-bolder mb-0"
              :title="username"
            >
              {{ username }}
            </p>
            <span
              class="navbar-company-name"
              :title="companyname"
            >{{ companyname }}</span>
          </div>
          <!-- <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/13-small.png')"
            class="badge-minimal"
            badge-variant="success"
          /> -->
        </template>

        <b-dropdown-item
          v-for="provider in providers"
          :key="provider.providerid"
          link-class="d-flex align-items-center"
          :href="providerAdminUrl(provider.providerid)"
        >
          <feather-icon
            size="16"
            icon="ExternalLinkIcon"
            class="mr-50 account-dropdown-icon"
          />
          <span
            class="provider-admin-label"
            :title="`Admin for ${provider.providername}`"
          >
            Admin for {{ provider.providername }}
          </span>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click.p.prevent="$router.push({name: 'account-your-usage'})"
        >
          <feather-icon
            size="16"
            icon="PieChartIcon"
            class="mr-50 account-dropdown-icon"
          />
          <span>Your Usage</span>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click.p.prevent="$router.push({name: 'account-details'})"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50 account-dropdown-icon"
          />
          <span>Account Details</span>
        </b-dropdown-item>

        <b-dropdown-item
          v-if="isCompanyAdmin"
          link-class="d-flex align-items-center"
          @click.p.prevent="$router.push({name: 'companyoverview'})"
        >
          <feather-icon
            size="16"
            icon="BriefcaseIcon"
            class="mr-50 account-dropdown-icon"
          />
          <span>Company Admin</span>
        </b-dropdown-item>

        <!-- <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="SettingsIcon"
            class="mr-50"
          />
          <span>Settings</span>
        </b-dropdown-item> -->

        <!-- <b-dropdown-divider /> -->

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50 account-dropdown-icon"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>

      <template v-if="!loggedIn">
        <b-button
          variant="primary"
          class="mr-1 ml-1 py-80"
          @click="$router.push({name : 'login'})"
        >
          Log In
        </b-button>
        <b-button
          variant="primary"
          class="py-80"
          @click="$router.push({name : 'register'})"
        >
          Register
        </b-button>
      </template>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BButton, BBadge, // BAvatar, BDropdownDivider,
} from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import BrandLogosMixin from '@/mixins/BrandLogosMixin.vue'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BButton,
    BBadge,
    // BAvatar,
    // BDropdownDivider,

    // Navbar Components
    DarkToggler,
  },
  mixins: [BrandLogosMixin],
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      brand: $themeConfig.app.brand,
      companyLogoImage1: $themeConfig.app.companyLogoImage1,
      companyLogoImage2: $themeConfig.app.companyLogoImage2,
    }
  },
  computed: {
    username() {
      return this.$store.state.auth.user.fullname
    },
    companyname() {
      return this.$store.state.auth.user.companyname
    },
    companySubscription() {
      const statuses = {
        premium: { label: 'Premium', variant: 'light-success' },
        standard: { label: 'Standard', variant: 'light-secondary' },
        trial: { label: 'Trial', variant: 'light-warning' },
      }
      return statuses[this.$store.getters['auth/companyStatus']] || null
    },
    loggedIn() {
      return this.$store.state.auth.isLoggedIn
    },
    isCompanyAdmin() {
      return this.$store.getters['auth/isCompanyAdmin']
    },
    providers() {
      return this.$store.state.auth.user.providers || []
    },
  },
  methods: {
    // Log the user out
    logout() {
      this.$store.dispatch('auth/logout')
    },
    providerAdminUrl(providerId) {
      const baseUrl = process.env.VUE_APP_CLASSIC_URL || ''
      return `${baseUrl.replace(/\/+$/, '')}/provideradmin.cfm?providerid=${encodeURIComponent(providerId)}`
    },
  },
}
</script>

<style lang="scss">
.header-navbar .dropdown-user-link {
  flex-wrap: nowrap;

  .navbar-account-text {
    min-width: 0;
    max-width: clamp(7rem, 18vw, 18rem);

    .user-name,
    .navbar-company-name {
      display: block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .navbar-company-status {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    height: 24px;
    padding: 0 0.6rem;
    border: 1px solid currentColor;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    .navbar-company-status-label {
      transform: translateY(2px);
    }
  }
}

.dropdown-user .dropdown-menu .account-dropdown-icon {
  width: 16px !important;
  min-width: 16px;
  height: 16px !important;
  flex: 0 0 16px;
  stroke-width: 2.25;
}

.dropdown-user .dropdown-menu .provider-admin-label {
  display: block;
  min-width: 0;
  max-width: min(210px, calc(100vw - 90px));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
